<div class="intro-area-start">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 text-center mt-3" data-label="title">
          <div class="h2 fw-bold" translate>HOME.TRUSTED_TRAVELER_TITLE_TEXT</div>
        </div>        
      </div>
      <div class="row mt-0">
        <div class="col-0 col-md-2"></div>
        <div class="col-12 col-md-8">
          <p class="ttp-subheader-text" translate>HOME.INTRO_TITLE_TTP</p>
        </div>
      </div>
    </div>
</div>

  <!-- // PROGRAM GRID -->
  <!-- <a name="program-grid"></a> -->
  <div class="container home-main-container">
    <div class="row">
      <div class="ttp-columns col-12">
        <div class="program-grid home-grid">
          <!-- <div class="row program-row"> -->
            <!-- <div class="col col-lg-4"> -->
              <div class="card intro-card">
                <div class="card-body d-flex flex-column">
                  <div class="h2">{{ 'HOME.FIND_WHAT_WORKS' | translate}}</div>
                  <p class="card-instructions">{{'HOME.FIND_WHAT_WORKS_INSTRUCTIONS' | translate}}</p>
                  <a href="#" class="btn btn-light mt-auto" data-bs-toggle="modal"
                    data-bs-target="#comparison-wizard">{{'HOME.START' | translate}}</a>
                </div>
              </div>
            <!-- </div>
            <div class="col col-lg-4"> -->
              <div class="card">
                <div class="card-header d-flex">
                  <img class="TSA-pre" src="assets/images/logos/tsaprecheck-official.png"
                    alt="{{'IMAGE_ALT.TSA_PRECHECK_LOGO' | translate}}"
                    role="heading" aria-level="2">
                  <div class="program-price-container ms-auto">
                    <span>{{'MODAL.FROM' | translate}}</span>
                    <h3 class="program-price program-price-air"><b>${{programPrices.TSA}}</b></h3>
                    <span>{{'HOME.FOR_5_YEARS' | translate}}</span>
                  </div>
                </div>
  
                <div class="card-body d-flex flex-column">
                  <p class="h3">{{'HOME.TSA_CARD_FOR' | translate}}</p>
                  <p [innerHTML]="'HOME.TSA_STREAMLINED_FOR' | translate"></p>
  
                  <div class="mt-auto">
                    <a class="btn btn-primary tsa-btn" tabindex="0" [attr.href]="TSA_LOGIN_URL"
                      (click)="logGetStartedProgram('TSA');" (keyup.enter)="logGetStartedProgram('TSA');" target="_blank"
                      rel="noopener noreferrer"><span>{{'HOME.APPLY_NOW' | translate}}<i
                          class="uswds-icon icon-launch"></i></span></a>
                  </div>
                </div>
              </div>
            <!-- </div> -->
  
            <!-- <div class="col  col-lg-4 "> -->
              <div class="card">
                <div class="card-header d-flex">
                  
                  <img class="global-entry" src="assets/images/logos/logo-global-entry.png"
                    alt="{{'IMAGE_ALT.GLOBAL_ENTRY_LOGO' | translate}}"
                    role="heading" aria-level="2">
                    
                  <div class="program-price-container ms-auto">
                    <h3 class="program-price program-price-air"><b>${{programPrices.UP}}</b></h3>
                    <span>{{'HOME.FOR_5_YEARS' | translate}}</span><br>
                    <span>{{'HOME.MINORS_FREE' | translate}}</span>
                  </div>
                </div>
  
                <div class="card-body d-flex flex-column">
                  <p class="h3">{{'HOME.UP_CARD_FOR' | translate}}</p>
                  <p [innerHTML]="'HOME.UP_STREAMLINED_FOR' | translate"></p>
                  <br>
                  <p><i><span [innerHTML]="'IMAGE_ALT.DOESINCLUDE_TSA_PRECHECK' | translate"></span></i></p>
  
                  <div class="mt-auto">
                    <a class="btn btn-primary" tabindex="0" (click)="logGetStartedProgram('UP'); showConsiderTSAModal();"
                      (keyup.enter)="logGetStartedProgram('UP');showConsiderTSAModal();" target="_blank"
                      rel="noopener noreferrer">{{'HOME.APPLY_NOW' | translate}}</a>
                    <a href="" class="learn-more ps-2 text-nowrap " [routerLink]="['programs-info']" [queryParams]="{code: 'UP'}"
                      translate>HOME.ABOUT.LEARN_MORE</a>
                  </div>
                </div>
              </div>
            <!-- </div> -->
  
            <!-- <div class="col col-lg-4"> -->
              <div class="card">
                <div class="card-header d-flex">
                  <img class="global-entry" src="assets/images/logos/logo-nexus.png"
                    alt="{{'IMAGE_ALT.NEXUS_LOGO' | translate}}"
                    role="heading" aria-level="2">
                  <div class="program-price-container ms-auto">
                    <h3 class="program-price program-price-air"><b>${{programPrices.NH}}</b></h3>
                    <span>{{'HOME.FOR_5_YEARS' | translate}}</span><br>
                    <span>{{'HOME.MINORS_FREE' | translate}}</span>
                  </div>
                </div>
  
                <div class="card-body d-flex flex-column">
                  <p class="h3">{{'HOME.NH_CARD_FOR' | translate}}</p>
                  <p [innerHTML]="'HOME.NH_STREAMLINED_FOR' | translate"></p>
                  <br>
                  <p><i>{{'PROGRAM_SELECTION.SELECT_A_PROGRAM.MAY_INCLUDE'| translate}} <span
                        [innerHTML]="'DASHBOARD.TSA_PRECHECK' | translate"></span></i></p>
  
                  <div class="mt-auto">
                    <a class="btn btn-primary" tabindex="0" (click)="logGetStartedProgram('NH');logIn()"
                      (keyup.enter)="logGetStartedProgram('NH');logIn();" target="_blank"
                      rel="noopener noreferrer">{{'HOME.APPLY_NOW' | translate}}</a>
                    <a href="" class="learn-more ps-2 text-nowrap" [routerLink]="['programs-info']" [queryParams]="{code: 'NH'}"
                      translate>HOME.ABOUT.LEARN_MORE</a>
                  </div>
                </div>
              </div>
            <!-- </div> -->
  
            <!-- <div class="col col-lg-4"> -->
              <div class="card">
                <div class="card-header d-flex">
                  <img class="global-entry" src="assets/images/logos/logo-sentri.png"
                    alt="{{'IMAGE_ALT.SENTRI_LOGO' | translate}}"
                    role="heading" aria-level="2">
                  <div class="program-price-container ms-auto">
                    <h3 class="program-price program-price-air"><b>${{programPrices.SH}}</b></h3>
                    <span>{{'HOME.FOR_5_YEARS' | translate}}</span><br>
                    <span>{{'HOME.MINORS_FREE' | translate}}</span>
                  </div>
                </div>
  
                <div class="card-body d-flex flex-column">
                  <p class="h3">{{'HOME.SH_CARD_FOR' | translate}}</p>
                  <p [innerHTML]="'HOME.SH_STREAMLINED_FOR' | translate"></p>
                  <br>
                  <p><i>{{'PROGRAM_SELECTION.SELECT_A_PROGRAM.MAY_INCLUDE'| translate}} <span
                        [innerHTML]="'DASHBOARD.TSA_PRECHECK' | translate"></span></i></p>
  
                  <div class="mt-auto">
                    <a class="btn btn-primary" tabindex="0" (click)="logGetStartedProgram('SH');logIn();"
                      (keyup.enter)="logGetStartedProgram('SH');logIn();" target="_blank"
                      rel="noopener noreferrer">{{'HOME.APPLY_NOW' | translate}}</a>
                    <a href="" class="learn-more ps-2 text-nowrap" [routerLink]="['programs-info']" [queryParams]="{code: 'SH'}"
                      translate>HOME.ABOUT.LEARN_MORE</a>
                  </div>
                </div>
              </div>
            <!-- </div> -->
  
            <!-- <div class="col col-lg-4"> -->
              <div class="card">
                <div class="card-header d-flex">
                  <img class="global-entry mt-2" src="assets/images/logos/logo-us-mexico-fast.jpg"
                    alt="{{'IMAGE_ALT.FAST_LOGO' | translate}}"
                    role="heading" aria-level="2">
                  <div class="program-price-container ms-auto">
                    <h3 class="program-price program-price-air"><b>${{programPrices.FAST}}</b></h3>
                    <span>{{'HOME.FOR_5_YEARS' | translate}}</span><br>
                  </div>
                </div>
  
                <div class="card-body d-flex flex-column">
                  <p class="h3">{{'HOME.FAST_CARD_FOR' | translate}}</p>
                  <p [innerHTML]="'HOME.FAST_STREAMLINED_FOR' | translate"></p>
  
                  <div class="mt-auto">
                    <a class="btn btn-primary" tabindex="0" (click)="logGetStartedProgram('FAST');logIn();"
                      (keyup.enter)="logGetStartedProgram('FAST');logIn();" target="_blank"
                      rel="noopener noreferrer">{{'HOME.APPLY_NOW' | translate}}</a>
                    <a href="" class="learn-more ps-2 text-nowrap" [routerLink]="['programs-info']" [queryParams]="{code: 'FAST'}"
                      translate>HOME.ABOUT.LEARN_MORE</a>
                  </div>
                </div>
              </div>
            <!-- </div> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
  </div>

  <div class="mt-5">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-4">
          <h2 style="color: #1f4f83;" class="ps-md-5 fw-bold">{{'HOME.TTP_OVERVIEW.NATIONAL_SECURITY' | translate}}</h2>
        </div>
        <div class="col-12 col-md-1">
        </div>
        <div class="col-12 col-md-6">
          <p class="fw-bold" style="font-size: 16px;" [innerHTML]="'HOME.TTP_OVERVIEW.RISK' | translate"></p>
          <p>{{'HOME.TTP_OVERVIEW.VETTING' | translate}}</p>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-5"  style="background-color: #f0f0f0">
    <div class="container">
      <div class="row pt-5 pb-5">
        <div class="col-12 col-md-4">
          <h2  class="ps-md-5 fw-bold"translate>HOME.ENROLLMENT.HOW_WORKS</h2>
          <p  class="ps-md-5">{{'HOME.ENROLLMENT.PROCESS' | translate}}</p>
        </div>
        <div class="col-12 col-md-1">
        </div>
        <div class="col-12 col-md-6">

          <!-- <div class="d-flex gap-3"> -->
          <div class="row">

            <div class="col-12 col-md-4">
              <p class="enrollment-title" translate>
                <i class="fa fa-globe" title="{{'IMAGE_ALT.APPLY' | translate}}"></i>HOME.ENROLLMENT.APPLY
              </p>
              <p class="enrollment-works-description">{{'HOME.ENROLLMENT.SUBMIT_APPLICATION' | translate}}</p>
              <a data-bs-target="#mdl-what-i-need" data-bs-toggle="modal" href="" class="enrollment-link" translate>HOME.ENROLLMENT.WHAT_INFO_NEEDED</a>
            </div>
  
            <div class="col-12 col-md-4">
              <p class="enrollment-title" translate>
                <i class="fa fa-user" title="{{'IMAGE_ALT.INTERVIEW' | translate}}"></i>HOME.ENROLLMENT.INTERVIEW
              </p>
              <p class="enrollment-works-description">{{'HOME.ENROLLMENT.INTERVIEW_INPERSON' | translate}}</p>
              <a target="_blank" class="enrollment-link" href="https://www.cbp.gov/travel/trusted-traveler-programs/global-entry/enrollment-arrival" rel="noopener" translate>MODAL.FIND_UP_EOA</a>
              <br>
              <a href="" class="enrollment-link" data-bs-toggle="modal" data-bs-target="#mdl-check-int-avail" translate>HOME.ABOUT.CHECK_INTERVIEW_AVAILABILITY</a>
            </div>
  
            <div class="col-12 col-md-4">
              <p class="enrollment-title" translate>
                <i class="far fa-id-card" title="{{'IMAGE_ALT.MEMBERSHIP' | translate}}"></i>HOME.ENROLLMENT.MEMBERSHIP
              </p>
              <p class="enrollment-works-description">{{'HOME.ENROLLMENT.ONCE_ACCEPTED' | translate}}</p>
              <p>{{'HOME.ENROLLMENT.MEMBERSHIP_LENGTH' | translate}}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>


  <div class="mt-5">
    <div class="container">
      <div class="row pt-5 pb-5">
        <div class="col-12 col-md-4">
          <h2  class="ps-md-5 fw-bold">{{'HOME.TOP_FAQ' | translate}}</h2>
          <p  class="ps-md-5">
            <a href="/faq?lang={{translate.currentLang}}" target="_blank">{{'HOME.VIEW_ALL_FAQS' | translate}}</a>
          </p>
        </div>
        <div class="col-12 col-md-1">
        </div>

        <div class="col-12 col-md-6">
          <div class="accordion accordion-flush top-faq-accordion" id="top-faq-accordion">
            <div *ngFor="let faq of popularFaqList; let i = index;" class="accordion-item">
                <p class="accordion-header" id="popFaqHeading{{i}}">
                    <button type="button" class="accordion-button collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#popFaqCollapse' + i">{{faq.title | translate}}</button>									
                </p>
                <div id="popFaqCollapse{{i}}" class="accordion-collapse collapse" data-bs-parent="#top-faq-accordion">
                    <div class="card-body">
                      <p [innerHTML]="faq.body "></p>
                    </div>
                </div>
            </div>
          </div>
        </div>


    </div>
  </div>

  <!-- <div class="mt-5">
    <div class="container-xl">
      <app-comparison-stepper></app-comparison-stepper>
    </div>
  </div> -->
    <!-- modals -->


    <!-- <info-modal style="width:initial;" [id]="'md5-learn-more'" [title]="'DASHBOARD.TSA_LEARN_MORE'" [buttonText]="'MODAL.BUTTON_CLOSE'"
      [translate-src]="'MODAL.LEARN_MORE_TSA'"></info-modal> -->
    <program-info-modal style="width:initial;" [id]="'md5-learn-more'" [title]="'DASHBOARD.TSA_LEARN_MORE'" [buttonText]="'MODAL.BUTTON_CLOSE'"
      [program]="'TSA'"
      [membershipLink]="'MODAL.LEARN_MORE_TSA_INFO.MEMBERSHIP_LINK'"
      [benefits]="'MODAL.LEARN_MORE_TSA_INFO.BENEFITS'"></program-info-modal>

    <!-- <info-modal [id]="'md2-learn-more'" [title]="'DASHBOARD.GLOBAL_ENTRY_LEARN_MORE'" [buttonText]="'MODAL.BUTTON_CLOSE'"
      [translate-src]="'MODAL.LEARN_MORE_GLOBAL_ENTRY'"></info-modal> -->
      <program-info-modal [id]="'md2-learn-more'" [title]="'DASHBOARD.GLOBAL_ENTRY_LEARN_MORE'" [buttonText]="'MODAL.BUTTON_CLOSE'"
        [program]="'UP'"
        [membershipLink]="'MODAL.LEARN_MORE_GLOBAL_ENTRY.MEMBERSHIP_LINK'"
        [benefits]="'MODAL.LEARN_MORE_GLOBAL_ENTRY.BENEFITS'"></program-info-modal>


    <!-- <info-modal [id]="'md3-learn-more'" [title]="'DASHBOARD.NEXUS_LEARN_MORE'" [buttonText]="'MODAL.BUTTON_CLOSE'"
      [translate-src]="'MODAL.LEARN_MORE_NEXUS_MODAL'"></info-modal> -->
      <program-info-modal [id]="'md3-learn-more'" [title]="'DASHBOARD.NEXUS_LEARN_MORE'" [buttonText]="'MODAL.BUTTON_CLOSE'"
        [program]="'NH'"
        [benefits]="'MODAL.LEARN_MORE_NEXUS.BENEFITS'"></program-info-modal>

    <!-- <info-modal [id]="'md4-learn-more'" [title]="'DASHBOARD.SENTRI_LEARN_MORE'" [buttonText]="'MODAL.BUTTON_CLOSE'"
      [translate-src]="'MODAL.LEARN_MORE_SENTRI_MODAL'"></info-modal> -->
      <program-info-modal [id]="'md4-learn-more'" [title]="'DASHBOARD.SENTRI_LEARN_MORE'" [buttonText]="'MODAL.BUTTON_CLOSE'"
        [program]="'SH'"
        [benefits]="'MODAL.LEARN_MORE_SENTRI.BENEFITS'"></program-info-modal>

    <!-- <info-modal [id]="'md6-learn-more'" [title]="'DASHBOARD.FAST_LEARN_MORE'" [buttonText]="'MODAL.BUTTON_CLOSE'"
      [translate-src]="'MODAL.LEARN_MORE_FAST_MODAL'"></info-modal> -->
      <program-info-modal [id]="'md6-learn-more'" [title]="'DASHBOARD.FAST_LEARN_MORE'" [buttonText]="'MODAL.BUTTON_CLOSE'"
        [program]="'FN'"
        [benefits]="'MODAL.LEARN_MORE_FAST.BENEFITS'"></program-info-modal>

    <info-modal [id]="'mdl-why-login'" [title]="'FAQ.WHY_LOGIN_GOV_TITLE'" [buttonText]="'MODAL.BUTTON_CLOSE'"
      [translate-src]="'FAQ.WHY_LOGIN_GOV_TEXT'"></info-modal>
    <info-modal [id]="'mdl-what-i-need'" [title]="'FAQ.WHAT_NEED_TITLE'" [buttonText]="'MODAL.BUTTON_CLOSE'"
      [translate-src]="'FAQ.WHAT_NEED_TEXT'"></info-modal>
    <info-modal [id]="'mdl-app-fee'" [title]="'FAQ.APP_FEE_TITLE'" [buttonText]="'MODAL.BUTTON_OK'" [translate-src]="'FAQ.APP_FEE_TEXT'"></info-modal>
    <info-modal [id]="'mdl-where-interviews'" [title]="'FAQ.WHERE_INTERVIEWS_TITLE'" [buttonText]="'MODAL.BUTTON_OK'"
      [translate-src]="'FAQ.WHERE_INTERVIEWS_TEXT'"></info-modal>
    <security-modal #securityModal [id]="'security-warn'"></security-modal>
    <security-modal [id]="'security-warn-gs'" [route]="'/getstarted'"></security-modal>
    <check-int-avail-modal [id]="'mdl-check-int-avail'"></check-int-avail-modal>
    <!-- // NEWS SCROLLER -->
    <!-- <go-news-scroller></go-news-scroller> -->
    <!-- <tsa-site-leaving [id]="'mdl-tsa-site-leaving'"></tsa-site-leaving> -->